import testUa from './testUa';

const isWeiBo = (): boolean => {
  const r = /(weibo)/gi;
  return testUa(r);
};

export default isWeiBo;
